module.exports = __webpack_public_path__ + "img/pointA_item4.21102197.png";